import {gql} from '@apollo/client';
import {USER_FRAGMENT} from '../fragments';

export const GET_USER = gql`
  ${USER_FRAGMENT}
  query getUser($uid: ID!) {
    getUser(uid: $uid) {
      ...UserCoreFields
      documentType
      document
      ranking
    }
  }
`;

export const GET_USERS = gql`
  query getUsers {
    getUsers {
      uid
      fullName
      address {
        country
        state
        city
      }
      gender
      clubId
      status
    }
  }
`;

export const VALIDATE_USER_INFORMATION = gql`
  query validateUserInformation($find: String!) {
    validateUserInformation(find: $find) {
      email
      phoneNumber
      document
    }
  }
`;
